import { hotjar } from 'react-hotjar'
import { config } from '../config'

export const initHotjar = (): void => {
  if (config.hotjarId) {
    hotjar.initialize({ id: config.hotjarId, sv: config.hotjarSv })
  }
}
